module.exports = __webpack_public_path__ + "static/media/smallThumbsUpNew.744befb2.svg";